module.exports = __webpack_public_path__ + "img/SpinnerGap.35e57684.svg";